import React from 'react'
import { ContainerField, TyanLineProcessing } from '@sencha/ext-modern'

import { getMixedProps } from './blockPublic'

const LineProcessing = ({ field, /* onChange, initValues, changedValues, */defaultStyle }) => {
	const { props, rest } = getMixedProps('_lineProcessing', [defaultStyle, field])
	return <ContainerField {...props}  >
		<TyanLineProcessing userCls='t-form-lineprocessing' errorTarget={undefined} flex={1} value={rest.value} />
	</ContainerField>
}

const renderLineProcessing = config => {
	const { key } = config.field || {}
	return <LineProcessing key={key} {...config} />
}

export default renderLineProcessing